import React from 'react';
import { Button } from 'antd';

import s from './FormFooter.module.scss';

export const FormFooter = () => {
  return (
    <div className={s.FormFooter}>
      <div className={s.btnsWrapper}>
        <Button type={'primary'} htmlType='submit'>
          Сохранить
        </Button>
        <Button type={'default'} htmlType='reset'>
          Отменить
        </Button>
      </div>
    </div>
  );
};
